import { Link as RouterLink } from 'react-router-dom';

import PropTypes from 'prop-types';

import { Box, Button, Grid, Link, Typography } from '@mui/material';

import GenericFormContainer from '../Forms/GenericFormContainer';

import { darkLogoUrl } from '../../utils';

import AppleLogin from './AppleLogin';
import AuthDivider from './AuthDivider';
import FacebookLoginComponent from './FacebookLogin';
import SignInWithGoogle from './SignInWithGoogle';
import { StyledSocialMediaButtonContainer } from './styledComponents';

const LoginComponent = (props) => {
  const {
    onSubmit,
    onResetRequested,
    userForgotPassword,
    signInWithFacebook,
    signInWithGoogle,
    signInWithApple,
    toggleForgotPasswordState,
    form,
    formData,
    isNotAllowedToLogin,
  } = props;

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      wrap="nowrap"
      sx={{
        margin: 'auto',
        height: '100%',
        width: '34rem',
        padding: '7rem 0 0 0',
      }}
    >
      <Box height="8rem" padding="0.5rem">
        <img style={{ height: '100%' }} src={darkLogoUrl} alt="Carson Logo" />
      </Box>
      <GenericFormContainer
        form={form}
        formData={formData}
        onSubmit={userForgotPassword ? onResetRequested : onSubmit}
        canBeUpdated={false}
        title="Login"
        submitText={userForgotPassword ? 'Reset Password' : 'Login'}
        customSubmitStyle={{ borderRadius: '20px' }}
        backButton={false}
        onLoad={() => {}}
        isCentered
        isFullWidthForm
        isFullWidthSubmit
      />
      <Box width="100%">
        <Button
          type="button"
          variant="outlined"
          disableElevation
          sx={{
            width: '100%',
            margin: '-1rem 0 0 0',
            borderRadius: '20px',
          }}
          onClick={(e) => toggleForgotPasswordState(e)}
        >
          {userForgotPassword ? 'Back' : 'Forgot Password?'}
        </Button>
        <AuthDivider />
        <StyledSocialMediaButtonContainer>
          <FacebookLoginComponent
            loginWithFacebook={signInWithFacebook}
            facebookButtonLabel="Sign in with Facebook"
          />
        </StyledSocialMediaButtonContainer>
        <StyledSocialMediaButtonContainer>
          <AppleLogin
            signInWithApple={signInWithApple}
            appleButtonLabel="Sign in with Apple"
          />
        </StyledSocialMediaButtonContainer>
        <StyledSocialMediaButtonContainer>
          <SignInWithGoogle onSignInWithGoogle={signInWithGoogle} isLogin />
        </StyledSocialMediaButtonContainer>
        <Grid container justifyContent="center" mt="2rem">
          <Typography align="center" fontSize="1.4rem">
            Note - Login to this application is by invitation only
          </Typography>
          {!!isNotAllowedToLogin && (
            <Typography align="center" fontSize="1.4rem">
              <Link component={RouterLink} to="/support">
                Download Resident App
              </Link>
            </Typography>
          )}
        </Grid>
      </Box>
    </Grid>
  );
};

LoginComponent.propTypes = {
  form: PropTypes.string.isRequired,
  formData: PropTypes.instanceOf(Array).isRequired,
  userForgotPassword: PropTypes.bool.isRequired,
  signInWithFacebook: PropTypes.func.isRequired,
  signInWithGoogle: PropTypes.func.isRequired,
  signInWithApple: PropTypes.func.isRequired,
  toggleForgotPasswordState: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onResetRequested: PropTypes.func.isRequired,
  isNotAllowedToLogin: PropTypes.bool,
};

export default LoginComponent;
